const inputField = document.getElementById("custom_input");
// Initialize new keys
const appState = {
  selectedWrap: null,
  raw_mode: false,
  enhance_prompt: false
};

document.getElementById("raw_mode").addEventListener("change", function () {
  appState.raw_mode = this.checked;
});

document.getElementById("enhance_prompt").addEventListener("change", function () {
  appState.enhance_prompt = this.checked;
});


document.addEventListener("DOMContentLoaded", function () {
  const customerId = window.shopifyCustomerId || null;

  document.querySelectorAll("#buy-btn").forEach(btn => {
    btn.addEventListener("click", async function () {
      if (btn.classList.contains("disabled")) return;

      const saveBtn = document.querySelector(".save-image-btn");
      const isDisabled = saveBtn?.classList.contains("disabled");
      const img = document.getElementById("output");

      // Get current URL params
      const currentParams = new URLSearchParams(window.location.search);

      // Base params for redirect
      const redirectParams = new URLSearchParams();
      redirectParams.set("syncMode", "select-pdp");

      // Append ALL existing params (including UTM)
      currentParams.forEach((value, key) => {
        redirectParams.set(key, value);
      });

      // Final redirect URL
      const redirectUrl = "/collections/all?" + redirectParams.toString();

      if (!customerId) {
        if (img && img.src) {
          setLocalStorage1Day("pdp-select-img", img.src);
        }
      } else {
        if (!isDisabled) {
          try {
            await saveImage();
          } catch (err) {
            console.error("Error saving image:", err);
          }
        }
      }

      window.location.href = redirectUrl;
    });
  });
});
function attachSvgIconListeners() {
  const ratioRadios = document.querySelectorAll('input[type="radio"][name="svg_icon"]');
  
  ratioRadios.forEach((radio) => {
    radio.addEventListener("change", () => { 
      const imgCount = Number(sessionStorage.getItem("img-count")) || 0;
      if (imgCount >= 1) {
        sendToAPI("change");
      } else {
        console.warn("Image count < 1, skipping API call on radio change.");
      }
    });
  });
}


function updateButtons() {
  const toggle = document.getElementById('toggle');
  const autoBtn = document.querySelector('.reimage-btn.is-auto');
  const manualBtn = document.querySelector('.reimage-btn.is-manual');
  const imgCount = Number(sessionStorage.getItem("img-count")) || 0;

  if (!toggle || !autoBtn || !manualBtn) {
    return;
  }

  if (toggle.checked) {
    if (imgCount >= 1) {
      autoBtn.style.display = 'flex';
      manualBtn.style.display = 'none';
    } else {
      autoBtn.style.display = 'none';
      manualBtn.style.display = 'none';
    }
  } else {
    autoBtn.style.display = 'none';
    manualBtn.style.display = 'flex';
  }
}
window.addEventListener('load', () => {
  updateButtons();

  const toggle = document.getElementById('toggle');
  if (toggle) {
    toggle.addEventListener('change', () => {
      updateButtons();
    });
  }
});
window.incrementSessionImageCount = function () {
  let count = Number(sessionStorage.getItem("img-count")) || 0; 
  count += 1;
  
  sessionStorage.setItem("img-count", count);
  updateButtons();
  return count;
  
}
let generationBtnClicked = false;

window.getCookie = function (name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

window.setCookie = function (name, value, hours = 1) {
  const expires = new Date(Date.now() + hours * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

window.showPopup = function () {
  const popup = document.getElementById("error-popup");
    const reportIssuePopup = document.getElementById("report-issue-popup");

  if (
    reportIssuePopup &&
    window.getComputedStyle(reportIssuePopup).display !== "none"
  ) {
    return;
  }
  if (popup) {
    popup.style.display = "flex";
    document.body.style.overflow = "hidden";
  }
};

window.hidePopup = function () {
  const popup = document.getElementById("error-popup");
  if (popup) {
    popup.style.display = "none";
    document.body.style.overflow = "";
  }
};

document.addEventListener("DOMContentLoaded", function () {
  sessionStorage.removeItem("img-count");
  window.loadUserAIImages();

  const output = document.getElementById("output");
  const inputField = document.getElementById("custom_input");
  const popup = document.getElementById("error-popup");
  const saveBtnnew = document.querySelector(".save-image-btn");
  const DownloadBtn = document.querySelector(".download-btn");
  const styleRadios = document.querySelectorAll(".style-thumb-ai input");
  const promptGroup = document.querySelector("#art-anh-prompt-group");
  const stylePromptInput = document.getElementById("prompt_input");
  

  let debounceTimer;
  if (!saveBtnnew.classList.contains("disabled")) { saveBtnnew.classList.add("disabled"); }
 if (!DownloadBtn.classList.contains("disabled")) { DownloadBtn.classList.add("disabled"); }
  function debounce(callback, delay = 600) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(callback, delay);
  }

  function togglePromptGroup() {
    const selected = document.querySelector(".style-thumb-ai input:checked");
    if (!promptGroup) return;

    if (selected && selected.value === "custom") {
      promptGroup.classList.add("show");
      promptGroup.style.display = "flex";
    } else {
      promptGroup.classList.remove("show");
      setTimeout(() => {
        if (!promptGroup.classList.contains("show")) {
          promptGroup.style.display = "none";
        }
      }, 300);
    }
  }

  const svgIcons = document.querySelectorAll('input[name="svg_icon"]');
  const toggleGroup = document.querySelector(".size-wrap");

  svgIcons.forEach(radio => {
    radio.addEventListener("change", () => {
      const ratio = document.querySelector('input[name="svg_icon"]:checked')?.value;
      const inputMsgerror = document.querySelector(".input-msg-wrap");
       inputMsgerror.style.display = "none";
      if (toggleGroup?.classList.contains("error-border")) {
        toggleGroup.classList.remove("error-border");
        inputMsgerror.style.display = "none";
      }
    });
  });

  togglePromptGroup();
  styleRadios.forEach((radio) => {
    radio.addEventListener("change", togglePromptGroup);
  });

  output.src =  "https://cdn.shopify.com/s/files/1/0926/7786/5836/files/Frame_2131332572_50a106e6-9d7c-48d4-a34d-3d3b6cdb61ce.png?v=1770113914";

 window.sendToAPI = function(trigger = "manual") {
  const toggle = document.getElementById("toggle");
  const inputField = document.getElementById("custom_input");
  const stylePromptInput = document.getElementById("prompt_input");
  const output = document.getElementById("output");
  const saveBtnnew = document.querySelector(".save-image-btn");
  const DownloadBtn = document.querySelector(".download-btn");
  const buyBtn = document.querySelector(".ai-button-full .button");

  if (!toggle || toggle.checked !== true) return;

  const style = document.querySelector('input[name="style_select"]:checked')?.value;
  const ratio = document.querySelector('input[name="svg_icon"]:checked')?.value;
  const prompt = inputField?.value.trim();
  const outputFormat = "jpeg";
  const stylePromptText = stylePromptInput?.value.trim() || "";
  const customerId = window.shopifyCustomerId || null;
  const sessionId = getLocalStorage1Day("sessionId");
  const selectedRadio = document.querySelector('input[name="orientation"]:checked');
  const orientation = selectedRadio ? selectedRadio.value : null;
const currentPageUrl = window.location.href; 
  let hasError = false;

  // Reset error borders
  document.getElementById("style-card")?.classList.remove("error-border");
  document.querySelector(".size-wrap")?.classList.remove("error-border");
  document.getElementById("prompt-card")?.classList.remove("error-border");

  if (!style) {
    document.getElementById("style-card")?.classList.add("error-border");
    hasError = true;
  }
  if (!ratio) {
    document.querySelector(".size-wrap")?.classList.add("error-border");
    hasError = true;
  }
  if (!prompt || prompt.length <= 3) {
    document.getElementById("prompt-card")?.classList.add("error-border");
    hasError = true;
  }
  if (hasError) return;

  if (style === "custom" && (!stylePromptInput || stylePromptText.length < 3)) {
    console.warn("Custom style requires at least 3 letters in #prompt_input.");
    return;
  }

  const isShopifyCustomerLoggedIn = Boolean(customerId);
  if (trigger === "change" && (!ratio || !prompt)) {
    console.warn("Skipping API call: Required fields not filled.");
    return;
  }
    const imgCount = incrementSessionImageCount();
  if (imgCount < 1) return;

  let paramsObj = { prompt, orientation, outputFormat };
  if (style === "custom") paramsObj.theme = stylePromptText;
  if (style) paramsObj.style = style;
  if (isShopifyCustomerLoggedIn) {
    paramsObj.customerId = customerId;
     paramsObj.sessionId = sessionId;
  } else {
    paramsObj.sessionId = sessionId;
  }
  if(ratio){
     paramsObj.aspect_ratio = ratio;
  }
  
 paramsObj.apiKey = window.Prompt2Prints.apiKey;
    paramsObj.page_url = currentPageUrl;
  const params = new URLSearchParams(paramsObj);
  // const url = `https://api.prompt2prints.com/streamwithflux?${params.toString()}`;
  const url = `https://api.prompt2prints.com/text-to-image?${params.toString()}`;
  try {
    const es = new EventSource(url);
    
    output.classList.add("blur");
    const imageQueue = [];
    let isDone = false;
   
    
    const displayInterval = setInterval(() => {
      if (imageQueue.length > 0) {
        const imageSrc = imageQueue.shift();
        output.src = imageSrc;
        output.classList.remove("blur");
        buyBtn.classList.remove("disabled");
        hidePopup();
        
      } else if (isDone) {
        clearInterval(displayInterval);
      }
    }, 200);

    es.addEventListener("image", (e) => {
      try {
        const data = JSON.parse(e.data);
        const imageSrc = data.base64Image || data.url;
        if (imageSrc) imageQueue.push(imageSrc);
        if (saveBtnnew.classList.contains("disabled")) { saveBtnnew.classList.remove("disabled"); }
         if (DownloadBtn.classList.contains("disabled")) { DownloadBtn.classList.remove("disabled"); }
      } catch (err) {
        console.error("Image event parse error:", err);
        showPopup();
        if (!saveBtnnew.classList.contains("disabled")) { saveBtnnew.classList.add("disabled"); }
         if (!DownloadBtn.classList.contains("disabled")) { DownloadBtn.classList.add("disabled"); }
      }
    });

    es.addEventListener("done", () => {
      isDone = true;
      es.close();
      output.classList.remove("blur");
      buyBtn.classList.remove("disabled");
      hidePopup();
      fetchCredits();
      if (saveBtnnew.classList.contains("disabled")) { saveBtnnew.classList.remove("disabled"); }
      if (DownloadBtn.classList.contains("disabled")) { DownloadBtn.classList.remove("disabled"); }
    });

    es.addEventListener("error", () => {
      isDone = true;
      showPopup();
      es.close();
      if (!saveBtnnew.classList.contains("disabled")) { saveBtnnew.classList.add("disabled"); }
       if (!DownloadBtn.classList.contains("disabled")) { DownloadBtn.classList.add("disabled"); }
    });
  } catch (error) {
    console.error("EventSource failed:", error);
    showPopup();
    if (!saveBtnnew.classList.contains("disabled")) { saveBtnnew.classList.add("disabled"); }
     if (!DownloadBtn.classList.contains("disabled")) { DownloadBtn.classList.add("disabled"); }
  }
};

  // Event listeners - only add if toggle is initially true
  if (toggle.checked === true) {
    
    inputField.addEventListener("input", function () {
      debounce(() => sendToAPI("input"));
    });

    if (stylePromptInput) {
      stylePromptInput.addEventListener("input", function () {
        debounce(() => sendToAPI("input"));
      });
    }

    const styleRadios1 = document.querySelectorAll('input[type="radio"][name="style_select"]');
    styleRadios1.forEach((radio) => {
      radio.addEventListener("change", () => {
        sendToAPI("change");
      });
    });

     const ratioRadios = document.querySelectorAll('input[type="radio"][name="svg_icon"]');
  
  ratioRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      const imgCount = Number(sessionStorage.getItem("img-count")) || 0;
      if (imgCount >= 1) {
        sendToAPI("change");
      } else {
        console.warn("Image count < 1, skipping API call on radio change.");
      }
    });
  });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const moreBtn = document.querySelector('.more-card');
  if (!moreBtn) return;

  let expanded = false;

  moreBtn.addEventListener('click', () => {
    const cards = document.querySelectorAll('.style-thumb-ai');

    if (!expanded) {
      cards.forEach(card => {
        if (getComputedStyle(card).display === 'none') {
          card.style.display = 'flex';
          card.dataset.revealed = 'true';
        }
      });

      moreBtn.classList.add('rotated');
      expanded = true;
    } else {
      cards.forEach(card => {
        if (card.dataset.revealed === 'true') {
          card.style.display = 'none';
          delete card.dataset.revealed;
        }
      });

      moreBtn.classList.remove('rotated');
      expanded = false;
    }
  });
});

window.loadUserAIImages = function () {
  const thumbnailsGrid = document.querySelector('.ai-thumbnails-grid.is-new');
  const thumbnailsGridBlack = document.querySelector('.ai-thumbnails-grid.is-black');
  if (!thumbnailsGrid) return;

  const customerId = window.shopifyCustomerId;
 
if (!customerId) {
  thumbnailsGridBlack.style.display = "grid";
  thumbnailsGrid.style.display = "none";

  setTimeout(() => {
    thumbnailsGridBlack.style.display = "none";
    thumbnailsGrid.style.display = "grid";
  }, 1000);
  return;

}

  fetch(`${window.Prompt2Prints.apiBase}/get-collection?customerId=${customerId}`, {
  method: "GET",
  headers: {
    "x-api-key": window.Prompt2Prints.apiKey
  }
})
    .then(res => res.json())
    .then(data => {
  if (data.images && data.images.length > 0) {
    thumbnailsGridBlack.style.display = "grid";
    thumbnailsGrid.style.display = "none";
    
    setTimeout(() => {
      thumbnailsGridBlack.style.display = "none";
      thumbnailsGrid.style.display = "grid";
      
      // Take only the first 4 images
      const images = data.images.slice(0, 4);
      
      // Get all existing images in the grid
      const existingImages = thumbnailsGrid.querySelectorAll('img');
      
      // Update or create exactly 4 images
      for (let i = 0; i < 4; i++) {
        if (existingImages[i]) {
          // Update existing image
          existingImages[i].src = images[i].url;
          existingImages[i].alt = images[i].prompt || "AI Creation";
        } else {
          // Create new image if not enough
          const imgEl = document.createElement("img");
          imgEl.src = images[i].url;
          imgEl.alt = images[i].prompt || "AI Creation";
          imgEl.loading = "lazy";
          thumbnailsGrid.appendChild(imgEl);
        }
      }
      
      // Remove any extra images beyond 4
      for (let i = 4; i < existingImages.length; i++) {
        existingImages[i].remove();
      }
      
    }, 1000);
  }
})
    .catch(err => {
      console.error("Failed to load user AI images:", err);
    });
};

window.loadUserAIImages();

let orientation = "portrait";

function startImageStream() {
  if (toggle.checked !== true) {
    return;
  }
  
  const inputField = document.getElementById("custom_input");
  const outputFormat = "jpeg";
  const style = document.querySelector('input[name="style_select"]:checked')?.value;
  const stylePromptInput = document.getElementById("prompt_input");
  const stylePromptText = stylePromptInput?.value.trim() || "";
  const prompt = inputField?.value.trim();
  const customerId = window.shopifyCustomerId;
  let lastImage = "";
  const isShopifyCustomerLoggedIn = Boolean(customerId);
  const imageElement = document.querySelector("#output");
  const imageUrl = imageElement ? imageElement.src : "";
  const sessionId = getLocalStorage1Day("sessionId");

  if (style === "custom" && (!stylePromptInput || stylePromptText.length < 3)) {
    console.warn("Skipping API call: Custom style requires at least 3 letters in #prompt_input.");
    return;
  }

  const output = document.getElementById("output");
  const paramsObj = {
    prompt,
    orientation,
    outputFormat,
    style: style || "default",
    imageUrl: imageUrl || "",
  };

  if (style === "custom") {
    paramsObj.theme = stylePromptText;
  }

  if (isShopifyCustomerLoggedIn) {
    paramsObj.customerId = customerId;
     paramsObj.sessionId = sessionId;
  } else {
    paramsObj.sessionId = sessionId;
  }

 paramsObj.apiKey = window.Prompt2Prints.apiKey;
  const params = new URLSearchParams(paramsObj);
  const url = `https://api.prompt2prints.com/streamGeneration?${params.toString()}`;

  try {
    const es = new EventSource(url);
    output.classList.add("blur");
    const imageQueue = [];
    let isDone = false;

    const displayInterval = setInterval(() => {
      if (imageQueue.length > 0) {
        const imageSrc = imageQueue.shift();
        output.src = imageSrc;

        output.classList.remove("blur");
        hidePopup();
        // fetchCredits();
      } else if (isDone) {
        clearInterval(displayInterval);
      }
    }, 200);

    es.addEventListener("image", (e) => {
      try {
        const data = JSON.parse(e.data);
        const imageSrc = data.base64Image || data.url;
        if (imageSrc) {
          imageQueue.push(imageSrc);
          lastImage = imageSrc;
        }
      } catch (err) {
        showPopup();
      }
    });

    es.addEventListener("done", () => {
      isDone = true;
      es.close();
       if (!isShopifyCustomerLoggedIn && lastImage) {
    localStorage.setItem("nonuser-image", lastImage);
  }
      output.classList.remove("blur");
      hidePopup();
      fetchCredits();
    });

    es.addEventListener("error", (e) => {
      isDone = true;
      es.close();
      showPopup();
    });
  } catch (error) {
    showPopup();
  }
}

document.querySelectorAll(".orientation-btn").forEach(btn => {
  btn.addEventListener("click", () => {
    const ratio = btn.getAttribute("data-size"); 
    orientation = ratio;

    document.querySelectorAll(".orientation-btn").forEach(b => b.classList.remove("active"));
    btn.classList.add("active");

    const toggleGroup = document.querySelector(".size-wrap");
    if (toggleGroup?.classList.contains("error-border")) {
      toggleGroup.classList.remove("error-border");
    }
    if (toggle.checked === true) {
      startImageStream();
    }
  });
});

async function savingimg() {
  const img = document.querySelector("#output");
  if (!img || !img.src) {
    alert("No image found!");
    return;
  }

  const printRatio = document.querySelector('input[name="svg_icon"]:checked')?.value;

  const selectedRadio = document.querySelector('input[name="orientation"]:checked');
  const orientation = selectedRadio ? selectedRadio.value : null;

  const savepopup = document.querySelector(".save-image-popup");
  savepopup.style.display = "flex";

  const imageUrl = img.src;
  const faceEnhancement = true;
  const shouldUpscale = true;

  const sessionId = getLocalStorage1Day("sessionId");
  const customerId = window.shopifyCustomerId;

  try {
    const response = await fetch(`${window.Prompt2Prints.apiBase}/save-for-print`, { 
      method: "POST",
              headers: {
        "x-api-key": window.Prompt2Prints.apiKey,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ imageUrl, customerId,sessionId, orientation, printRatio })
    });

    const data = await response.json();
    savepopup.style.display = "none";

    if (data.error) throw new Error(data.error);
    const img = document.getElementById("output");
    if (img) {
      setLocalStorage1Day("pdp-select-img", data.imageUrl);
    }
      if (data.tags && Array.isArray(data.tags)) {
              setLocalStorage1Day("select-tags", JSON.stringify(data.tags));
            }
    fetchCredits();
  } catch (error) {
    savepopup.style.display = "none";
    console.error(error);
    showPopup();
  }
}
function showNoCreditPopup() {
  document.getElementById("no-credit-popup")?.classList.add("active");
}

// ==========================================
// BLOCKED TERMS LIST
// ==========================================
const BLOCKED_TERMS = [
  "marvel", "mcu", "avengers",
  "spiderman", "spider man",
  "ironman", "iron man",
  "captain america", "thor", "hulk",
  "wolverine", "deadpool", "venom",

  "disney", "pixar", "mickey", "minnie",
  "elsa", "frozen",

  "star wars", "darth vader", "yoda",
  "mandalorian", "grogu", "baby yoda",

  "dc", "justice league",
  "batman", "superman",
  "wonder woman", "joker", "harley quinn",

  "nintendo", "pokemon", "pokémon",
  "pikachu", "mario", "luigi", "zelda"
];


// ==========================================
// NORMALIZE FUNCTION
// ==========================================
function normalizePrompt(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}


// ==========================================
// BLOCK CHECK FUNCTION
// ==========================================
function containsBlockedTerm(text) {
  const normalized = normalizePrompt(text);
  return BLOCKED_TERMS.some(term => {
    const regex = new RegExp(`\\b${term}\\b`, "i");
    return regex.test(normalized);
  });
}



function manual(trigger = "manual") {
  if (toggle.checked !== true) {

    const style = document.querySelector('input[name="style_select"]:checked')?.value;
    const ratio = document.querySelector('input[name="svg_icon"]:checked')?.value;
    const buyBtn = document.querySelector(".ai-button-full .button");
       const generateBtnwrap = document.querySelector(".reimage-btn.is-manual");
    const prompt = inputField?.value.trim();
    const outputFormat = "jpeg";

    const saveBtnnew = document.querySelector(".save-image-btn");
    const DownloadBtn = document.querySelector(".download-btn");
    const stylePromptInput = document.getElementById("prompt_input");
    const stylePromptText = stylePromptInput?.value.trim() || "";
    const customerId = window.shopifyCustomerId || null;
    const sessionId = getLocalStorage1Day("sessionId");
const currentPageUrl = window.location.href; 
    const selectedRadio = document.querySelector('input[name="orientation"]:checked');
    const orientation = selectedRadio ? selectedRadio.value : null;

    let hasError = false;
    let noCreditError = false;

   document.getElementById("style-card")?.classList.remove("error-border");
    document.querySelector(".size-wrap")?.classList.remove("error-border");
    document.getElementById("prompt-card")?.classList.remove("error-border");

    if (!style) {
      document.getElementById("style-card")?.classList.add("error-border");
      hasError = true;
    }

    if (!ratio) {
      document.querySelector(".size-wrap")?.classList.add("error-border");
      hasError = true;
    }

    if (!prompt || prompt.length <= 3) {
      document.getElementById("prompt-card")?.classList.add("error-border");
      hasError = true;
    }

    if (hasError) return;

    if (style === "custom" && stylePromptText.length < 3) return;

    if (trigger === "change" && (!ratio || !prompt)) return;

     // ==========================================
    // BLOCKED WORD CHECK
    // ==========================================

    const fullTextToCheck = `
      ${prompt}
      ${stylePromptText}
    `;

    if (containsBlockedTerm(fullTextToCheck)) {
     showmsgpop(
 "That request includes restricted terms. Please describe the idea without using brand or character names.",
 "error"
);
      return;
    }

    let paramsObj = {
      prompt,
      orientation,
      outputFormat
    };
    
    if (ratio) paramsObj.aspect_ratio = ratio;
    if (style === "custom") paramsObj.theme = stylePromptText;
    if (appState.enhance_prompt === true) paramsObj.enhance_prompt = true;
    if (appState.raw_mode === true) paramsObj.raw_mode = true;
    if (style) paramsObj.style = style;

    if (customerId) {
      paramsObj.customerId = customerId;
      paramsObj.sessionId = sessionId;
    } else {
      paramsObj.sessionId = sessionId;
    }
    
 paramsObj.apiKey = window.Prompt2Prints.apiKey;
 paramsObj.page_url = currentPageUrl;
    const params = new URLSearchParams(paramsObj);
    const url = `https://api.prompt2prints.com/text-to-image?${params.toString()}`;

    try {
      const es = new EventSource(url);
    if (generateBtnwrap) {
      generateBtnwrap.classList.add("disabled");
      generateBtnwrap.style.opacity = "0.5";
      generateBtnwrap.style.pointerEvents = "none";
    }
      const loaderOverlay = document.getElementById("processingOverlay");
      loaderOverlay.style.display = "block";
      output.classList.add("blur");
      showRandomOverlayText();
      let factInterval = setInterval(showRandomOverlayText, 4000);

      const imageQueue = [];
      let isDone = false;

       const displayInterval = setInterval(() => {
        if (imageQueue.length > 0) {
          const imageSrc = imageQueue.shift();
          output.src = imageSrc;
          output.classList.remove("blur");
          buyBtn.classList.remove("disabled");
        hidePopup();
       if (saveBtnnew.classList.contains("disabled")) { saveBtnnew.classList.remove("disabled"); }
       if (DownloadBtn.classList.contains("disabled")) { DownloadBtn.classList.remove("disabled"); }

          
        } else if (isDone) {
          clearInterval(displayInterval);
        }
      }, 200);

      // ==================================
      // IMAGE STREAM
      // ==================================
      es.addEventListener("image", e => {
        try {
          const data = JSON.parse(e.data);

          // No credits inside SSE
          if (data.error && data.error.toLowerCase().includes("no more credits")) {
            noCreditError = true;
            es.close();
            stopUI();
            showNoCreditPopup();
            return;
          }

          const img = data.base64Image || data.url;
          if (img) {
            imageQueue.push(img);
              // STORE IMAGE DATA
            const generatedImage = {
              url: data.url,
              pageUrl: window.location.pathname + window.location.hash,
              pageName: "image-generation"
            };

            localStorage.setItem("lastGeneratedImage", JSON.stringify(generatedImage));
          }
        } catch {}
      });

      // ==================================
      // DONE
      // ==================================
      es.addEventListener("done", () => {
        isDone = true;
        es.close();
        if (generateBtnwrap) {
    generateBtnwrap.classList.remove("disabled");
    generateBtnwrap.style.opacity = "1";
    generateBtnwrap.style.pointerEvents = "auto";
  }
         const loaderOverlay = document.getElementById("processingOverlay");
      output.classList.remove("blur");
      loaderOverlay.style.display = "none";
      clearInterval(factInterval);
      factInterval = null;

      buyBtn.classList.remove("disabled");
      hidePopup();
      fetchCredits();
      if (saveBtnnew.classList.contains("disabled")) { saveBtnnew.classList.remove("disabled"); }
      if (DownloadBtn.classList.contains("disabled")) { DownloadBtn.classList.remove("disabled"); }
      });

      // ==================================
      // STREAM ERROR → check JSON
      // ==================================
      es.addEventListener("error", async () => {
        es.close();
        isDone = true;

        // Ask server what happened
        try {
          const res = await fetch(url);
          const data = await res.json();

          if (data.error && data.error.toLowerCase().includes("no more credits")) {
            showNoCreditPopup();
          } else {
            showPopup();
            if (!saveBtnnew.classList.contains("disabled")) { saveBtnnew.classList.add("disabled"); }
              if (!DownloadBtn.classList.contains("disabled")) { DownloadBtn.classList.add("disabled"); }
          }
        } catch {
          showPopup();
            if (!saveBtnnew.classList.contains("disabled")) { saveBtnnew.classList.add("disabled"); }
     if (!DownloadBtn.classList.contains("disabled")) { DownloadBtn.classList.add("disabled"); }
        }

        stopUI();
      });

    function stopUI() {
  loaderOverlay.style.display = "none";
  output.classList.remove("blur");
  clearInterval(factInterval);

  buyBtn.classList.add("disabled");
  saveBtnnew.classList.add("disabled");
  DownloadBtn.classList.add("disabled");

  // Safety: restore Generate
  if (generateBtnwrap) {
    generateBtnwrap.classList.remove("disabled");
    generateBtnwrap.style.opacity = "1";
    generateBtnwrap.style.pointerEvents = "auto";
  }
}

    } catch {
      showPopup();
    }
  }
}




document.addEventListener("DOMContentLoaded", function () {
  const generationBtn1 = document.querySelector(".reimage-btn.is-manual");
  if (generationBtn1) {
    generationBtn1.addEventListener("click", function () {

      manual("manual"); 
       generationBtnClicked = true;
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const generationBtn2 = document.querySelector(".reimage-btn.is-auto");
  if (generationBtn2) {
    generationBtn2.addEventListener("click", function () {

    sendToAPI("manual");
       generationBtnClicked = true;
    });
  }
});


async function saveImage() {
 const customerId = window.shopifyCustomerId;
  const saveBtn = document.querySelector(".save-image-btn");

 if (!customerId) {
  if (!saveBtn.classList.contains("disabled")) { 
    saveBtn.classList.add("disabled"); 
  }

   const currentPageUrl = window.location.href;

  const returnUrl = encodeURIComponent(
    window.location.pathname + window.location.search + "#image-generation-scroll"
  );

  persistImageState();

  // Save generation status
   const generationState = {
    status: true,
    btn: "collection-save-btn",
    pageUrl: currentPageUrl,
    pageName: "image-generation"
  };

  localStorage.setItem("lastGenerationStatus", JSON.stringify(generationState));


  window.location.href = `/account/login?return_url=${returnUrl}`;

  return;
}



  const img = document.querySelector("#output");
  if (!img || !img.src) {
    alert("No image found!");
    return;
  }

   const printRatio = document.querySelector('input[name="svg_icon"]:checked')?.value;

  const generationState = JSON.parse(localStorage.getItem("lastGenerationStatus"));
  const selectedRadio = document.querySelector('input[name="orientation"]:checked');
  const orientation = selectedRadio ? selectedRadio.value : null;

  const savepopup = document.querySelector(".save-image-popup");
  savepopup.style.display = "flex";

  const imageUrl = img.src;
  const faceEnhancement = true;
  const shouldUpscale = true;


  const sessionId = getLocalStorage1Day("sessionId"); 
  

  if (saveBtn) {
  if (!saveBtn.classList.contains("disabled")) { saveBtn.classList.add("disabled"); }
  }

  try {
    const response = await fetch(`${window.Prompt2Prints.apiBase}/save-for-print`, {
      method: "POST",
            headers: {
        "x-api-key": window.Prompt2Prints.apiKey,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ imageUrl, customerId, sessionId,orientation, printRatio })
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.statusText}`);
    }

    const textResponse = await response.text();

    if (generationState && generationState.status === true) {
  generationState.status = false;
          localStorage.setItem("lastGenerationStatus", JSON.stringify(generationState));
          console.log("Updated generation state status to false");
         
 }

    let data;
    try {
      data = JSON.parse(textResponse);
    } catch (jsonError) {
      throw new Error("Failed to parse JSON response: " + jsonError.message);
    }

    savepopup.style.display = "none";

    if (data.error) throw new Error(data.error);

   if (!saveBtn.classList.contains("disabled")) { saveBtn.classList.add("disabled"); }
    setLocalStorage1Day("pdp-select-img", data.imageUrl);
    
      if (data.tags && Array.isArray(data.tags)) {
              setLocalStorage1Day("select-tags", JSON.stringify(data.tags));
            }

    const thumbnailsGrid = document.querySelector('.ai-thumbnails-grid');
    if (thumbnailsGrid && typeof window.loadUserAIImages === 'function') {
      window.loadUserAIImages();
    }
fetchCredits();

  } catch (error) {
    savepopup.style.display = "none";
    console.error("Error:", error);
    showPopup();
  } finally {
   if (!saveBtn.classList.contains("disabled")) { saveBtn.classList.add("disabled"); }
  }
}
  function persistImageState() {
    const currentGeneratedImageUrl = document.getElementById("output").src;
       const printRatio = document.querySelector('input[name="svg_icon"]:checked')?.value;

  const selectedRadio = document.querySelector('input[name="orientation"]:checked');
  const orientation = selectedRadio ? selectedRadio.value : null;


  const sessionId = getLocalStorage1Day("sessionId"); 
  sessionStorage.setItem("imageGenState", JSON.stringify({
    imageUrl: currentGeneratedImageUrl,
    printRatio: printRatio,
    orientation : orientation,
    sessionId : sessionId
  }));
}

document.addEventListener("DOMContentLoaded" , ()=> {
  const state = sessionStorage.getItem("imageGenState");
  const finalState = JSON.parse(state);

if (state) {
  const imageContainer = document.getElementById("output");
  imageContainer.src = finalState.imageUrl;

  const orientation = finalState.orientation;
  const printRatio = finalState.printRatio;
  if (orientation) {
  const orientationInput = document.querySelector(
    `input[name="orientation"][value="${orientation}"]`
  );
  if (orientationInput) orientationInput.click();
}

if (printRatio) {
  const ratioInput = document.querySelector(
    `input[name="svg_icon"][value="${printRatio}"]`
  );
  if (ratioInput) ratioInput.click();
}

  sessionStorage.removeItem("imageGenState");
    const saveBtn = document.querySelector(".save-image-btn");
    saveBtn.classList.remove("disabled");
}
})


document.querySelector(".save-image-btn")?.addEventListener("click", saveImage);


document.addEventListener("DOMContentLoaded", () => {
  const switchInput = document.getElementById("toggle");
  const switchContainer = document.querySelector(".switch-container");

  function updateSwitchContainerClass() {
    if (switchInput.checked) {
      switchContainer.classList.add("checked");
      switchContainer.classList.remove("unchecked");
    } else {
      switchContainer.classList.add("unchecked");
      switchContainer.classList.remove("checked");
    }
  }
  updateSwitchContainerClass();
  switchInput.addEventListener("change", updateSwitchContainerClass);
});

